import { render, staticRenderFns } from "./LawLedesExcelReadForm.vue?vue&type=template&id=a2ffbc30&"
import script from "./LawLedesExcelReadForm.vue?vue&type=script&lang=js&"
export * from "./LawLedesExcelReadForm.vue?vue&type=script&lang=js&"
import style0 from "./LawLedesExcelReadForm.vue?vue&type=style&index=0&id=a2ffbc30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports